<template>
  <v-container id="reference-term-list">
    <app-city-header :payload="city"> </app-city-header>
    <v-row>
      <v-col>
        <app-group-solution-by-city-combobox
          :filter="filter"
          :onlyEnableGroupSolutionList="true"
        ></app-group-solution-by-city-combobox>
      </v-col>
      <v-col>
        <app-city-solution-combobox
          :municipioSolucao="filter"
          :allSolutions="solutions"
        ></app-city-solution-combobox>
      </v-col>
      <v-col>
        <app-city-task-combobox :filter="filter"></app-city-task-combobox>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3">
        <v-tabs vertical>
          <v-tab
            @click="tab = 0"
            :to="'/cidade/' + this.$route.params.id + '/termo-referencia/' + 0"
          >
            <v-icon left>mdi-axis-arrow</v-icon>
            {{
              isAT
                ? "Grupos de iniciativas"
                : isGov
                ? "Grupos de fases"
                : "Grupos de soluções"
            }}
          </v-tab>
          <v-tab
            @click="tab = 1"
            :to="'/cidade/' + this.$route.params.id + '/termo-referencia/' + 1"
          >
            <v-icon left>mdi-beaker-outline</v-icon>
            {{ isAT ? "Iniciativas" : isGov ? "Fases" : "Soluções" }}
          </v-tab>
          <v-tab
            @click="tab = 2"
            :to="'/cidade/' + this.$route.params.id + '/termo-referencia/' + 2"
          >
            <v-icon left>mdi-calendar-check-outline</v-icon>
            {{ isAT || isGov ? "Atividades" : "Tarefas" }}
          </v-tab>
          <v-tab
            @click="tab = 3"
            :to="'/cidade/' + this.$route.params.id + '/termo-referencia/' + 3"
            v-if="!isGov"
          >
            <v-icon left>mdi-book-search-outline</v-icon>
            Evidências
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="9">
        <GroupSolutionList v-if="tab == 0" :filter="filter"></GroupSolutionList>
        <SolutionList v-if="tab == 1" :filter="filter"></SolutionList>
        <TasksList v-if="tab == 2" :filter="filter"></TasksList>
        <EvidencesList v-if="tab == 3" :filter="filter"></EvidencesList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppSolutionList from "@/modules/solution/components/city/List";

import { AppCityHeader, cityAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppGroupSolutionByCityCombobox from "./groups-solution/ComboboxByCity.vue";
import AppCitySolutionCombobox from "./solutions/Combobox";
import AppCityTaskCombobox from "./tasks/Combobox.vue";
import GroupSolutionList from "./groups-solution/List";
import SolutionList from "./solutions/List";
import TasksList from "./tasks/List";
import EvidencesList from "./evidences/List";

export default {
  components: {
    AppSolutionList,
    AppCityHeader,
    AppGroupSolutionByCityCombobox,
    AppCitySolutionCombobox,
    AppCityTaskCombobox,
    GroupSolutionList,
    SolutionList,
    TasksList,
    EvidencesList,
  },
  computed: {
    ...mapGetters(["isAT", "isGov"]),
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      city: null,
      filter: {
        municipioSolucao: {},
        municipioTarefa: {},
        municipioGrupoSolucao: null,
      },
      tab: this.$route.params.tab,
      solutions: [],
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    loadCity() {
      this.setLoading(true);
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.city = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },

    mounted() {
      if (this.isAT) {
        this.breadcrumbs = [
          {
            text: "Grupos de Iniciativas",
            disabled: true,
            href: "termo-referencia",
          },
        ];
      }
      this.loadCity();
    },
  },
};
</script>

<style lang="scss">
@import "../style.scss";
</style>
